import { UtilizationPanel } from '@cdk-prod/fortellis-app-utilization-component';
import gql from 'graphql-tag';
import { getApolloClient } from './GraphQLClient';
import { fortellisTheme } from 'cdk-radial';
import { IntlProvider } from 'react-intl';
import { ThemeProvider } from 'styled-components';
import localeData from '@cdk-prod/fortellis-app-utilization-component/src/locales/data.json';
import React, { useState } from 'react';

const moment = require('moment');

const locale = 'en';
const messages = localeData['en'];

const UtilizationContainer = props => {
  const { solutionId, startDate, endDate, solutions, entity } = props;
  const [isLoading, setIsLoading] = useState(true);

  const getUtilizationQuery = gql`
    query ($solutionId: String, $startDate: String, $endDate: String) {
  getUtilization(
    solutionId: $solutionId
    startDate: $startDate
    endDate: $endDate
  ) {
    utilizationByAPI {
      appId
      apiId
      apiType
      apiName
      apiOrgName
      apiOrgId
      transactionCount
      skipPricing
      isContracted
      integrationStartDate
      integrationEndDate
      pricingPlans {
        id
        type
        name
        startDate
        endDate
        transactionCount
        containers {
          name
          description
          isFreeContainer
          quota
          endPoints {
            route
            verb
            summary
            transactionCount
          }
        }
      }
    }

    utilizationByBundles {
      bundleId
      bundleName
      startDate
      endDate
      pricePlanId
      integrationStatus

      apis {
        id
        type
        instanceIds {
          id
          version
        }
      }

      pricingPlan {
        id
        planName
        planType
        price
        freeDays

        containers {
          id
          name
          quota
          overage
          isFree

          endpoints {
            instanceId
            route
            verb
            summary
          }

          channels {
            asyncApiId
            channel
          }
        }
      }
    }
  }
}
  `;

  const getUtilizationData = async ({ solutionId, startDate, endDate }) => {
    try {
      setIsLoading(true);
      const client = getApolloClient();
      const response = await client.query({
        query: getUtilizationQuery,
        variables: {
          solutionId: solutionId,
          startDate: moment(startDate)
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          endDate: moment(endDate)
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss')
        }
      });
      setIsLoading(false);
      return response;
    } catch (error) {
      console.error('Error fetching utilization data:', error);
      setIsLoading(false);
    }
  };

  return (
    <IntlProvider locale={locale} messages={messages}>
      <ThemeProvider theme={fortellisTheme}>
        <UtilizationPanel
          solutionId={solutionId}
          getUtilizationData={getUtilizationData}
          startDate={startDate}
          endDate={endDate}
          entity={entity}
          solutions={solutions}
          loading={isLoading}
        />
      </ThemeProvider>
    </IntlProvider>
  );
};

export default UtilizationContainer;
